module.exports = __webpack_public_path__ + "static/media/headerChurch.d7af3650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/images/headerChurch.jpg
// module id = 987
// module chunks = 0